import { cn } from "@omni/utils/styles";

import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

type Props = {
    className?: string;
};

export const Chevron = ({ className }: Props) => {
    const { showMenuOnHover, menuElement, hideChevron, isActive } =
        useHeaderButtonContext();

    if (showMenuOnHover || !menuElement || hideChevron) return null;

    return (
        <i
            className={cn(
                "las la-angle-down",
                "tw:transition-transform tw:ml-2 tw:h-full tw:items-center",
                {
                    "tw:rotate-180": isActive
                },
                className
            )}
        />
    );
};
